module.exports = __webpack_public_path__ + "assets/img/culture_img3.9b3e9e74.png";